import { RowClassParams, RowStyle } from "ag-grid-community";
import { includes } from "lodash";

export const getRowStyle = (params: RowClassParams<any>): RowStyle | undefined => {
    let numberOfPos = 0;
    let numberOfZeroRD = 0;
    for (const key in params.node.data) {
        if (!includes(key, "pos")) continue;
        if (params.node.data[key].bl === 0 || params.node.data[key].bl === undefined)
            numberOfZeroRD += 1;

        numberOfPos += 1;
    }
    if (numberOfPos !== 0 && numberOfPos === numberOfZeroRD) return { background: "#b8e994" };
};
